import React from 'react';
/**
 * DjayAvatar part — mouth per emotion.
 * Verbatim extraction of the former `renderMouth()` (incl. the `showMouth`
 * size gate and `showDetails` happy-mouth fill).
 */
import type { DjayEmotion, VariantColorScheme } from '../types';
interface MouthProps {
  emotion: DjayEmotion;
  colors: VariantColorScheme;
  showMouth: boolean;
  showDetails: boolean;
}
export function Mouth({
  emotion,
  colors,
  showMouth,
  showDetails
}: MouthProps) {
  if (!showMouth) return null;
  switch (emotion) {
    case 'excited':
    case 'celebrating':
    case 'proud':
      return <g className="djay-mouth" data-id="element-3264">
          <path d="M80 130 Q100 165 120 130 Z" fill={colors.mouthColor} data-id="element-3265" />
          <path d="M90 145 Q100 155 110 145 Z" fill="#EF4444" data-id="element-3266" />
        </g>;
    case 'surprised':
      return <g className="djay-mouth" data-id="element-3267">
          <ellipse cx="100" cy="138" rx="6" ry="10" fill={colors.mouthColor} data-id="element-3268" />
        </g>;
    case 'thinking':
      return <g className="djay-mouth" data-id="element-3269">
          <path d="M90 135 Q95 132 100 135 T110 135" stroke={colors.mouthColor} strokeWidth="3" strokeLinecap="round" fill="none" data-id="element-3270" />
        </g>;
    case 'sleeping':
      return <g className="djay-mouth" data-id="element-3271">
          <path d="M95 138 Q100 142 105 138" stroke={colors.mouthColor} strokeWidth="3" strokeLinecap="round" fill="none" data-id="element-3272" />
        </g>;
    case 'pointing':
      return <g className="djay-mouth" data-id="element-3273">
          <path d="M90 135 Q105 142 115 130" stroke={colors.mouthColor} strokeWidth="3.5" strokeLinecap="round" fill="none" data-id="element-3274" />
        </g>;
    case 'encouraging':
      return <g className="djay-mouth" data-id="element-3275">
          <path d="M85 135 Q100 145 115 135" stroke={colors.mouthColor} strokeWidth="3.5" strokeLinecap="round" fill="none" data-id="element-3276" />
        </g>;
    case 'happy':
    default:
      return <g className="djay-mouth" data-id="element-3277">
          <path d="M82 133 Q100 152 118 133" stroke={colors.mouthColor} strokeWidth="3.5" strokeLinecap="round" fill="none" data-id="element-3278" />
          {showDetails && <path d="M85 134 Q100 148 115 134" fill={colors.mouthColor} fillOpacity="0.15" data-id="element-3279" />}
        </g>;
  }
}